import React from 'react';
import { Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { FilterType } from '../types';

interface FilterOption {
  value: FilterType;
  label: string;
}

interface FilterSelectProps {
  value: FilterType;
  onChange: (e: SelectChangeEvent) => void;
  options: FilterOption[];
  disabled?: boolean;
  filterDisableOption?: boolean;
}

/**
 * Component for rendering a filter type select dropdown
 */
const FilterSelect: React.FC<FilterSelectProps> = ({ 
  value, 
  onChange, 
  options, 
  disabled = false,
  filterDisableOption = false
}) => {
  const displayOptions = filterDisableOption 
    ? options.filter(opt => opt.value !== FilterType.DISABLE)
    : options;

  return (
    <Select
      fullWidth
      size="small"
      value={value}
      onChange={onChange}
      disabled={disabled}
    >
      {displayOptions.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default FilterSelect;
